import { MetricCards } from "@/Components/v2/molecule/MetricCards";
import { HIDE_DECIMAL, useConfig, NO_SYMBOL } from "@/hooks/useConfig";
import {
  WeeklyMetricAverages,
  WeeklyMetricAveragesMapping,
} from "@/pages/investment-levels/helpers/calculateWeeklyMetricAverages";

const SummaryData = ({
  totalSpend,
  totalRevenue,
  meanYieldPerWeek,
  meanRoiPerWeek,
}: WeeklyMetricAverages) => {
  const { config } = useConfig();
  const formatCurrency = config.currency.formatCurrency;
  const revenueFormatterOptions = config.showReturnInsteadOfRevenue
    ? { ...NO_SYMBOL, ...HIDE_DECIMAL }
    : HIDE_DECIMAL;
  const yieldFormatterOptions = config.showReturnInsteadOfRevenue ? NO_SYMBOL : {};

  const metricCards = [
    {
      label: WeeklyMetricAveragesMapping.TOTAL_SPEND,
      value: totalSpend ? formatCurrency(totalSpend, HIDE_DECIMAL) : "",
    },
    {
      label: config.showReturnInsteadOfRevenue
        ? WeeklyMetricAveragesMapping.TOTAL_RETURN
        : WeeklyMetricAveragesMapping.TOTAL_REVENUE,
      value: totalRevenue ? formatCurrency(totalRevenue, revenueFormatterOptions) : "",
    },
    {
      label: WeeklyMetricAveragesMapping.MEAN_YIELD_PER_WEEK,
      value: meanYieldPerWeek ? formatCurrency(meanYieldPerWeek, yieldFormatterOptions) : "",
    },
    {
      label: WeeklyMetricAveragesMapping.MEAN_ROI_PER_WEEK,
      value: meanRoiPerWeek ? `${meanRoiPerWeek}%` : "",
    },
  ];

  return <MetricCards metrics={metricCards} />;
};

export default SummaryData;
